import Vue from 'vue'
import VueRouter from 'vue-router'
import Top from '../views/Top.vue'

Vue.use(VueRouter)

	const routes = [
	{
		path: '/',
		name: 'Top',
		component: Top,
		meta: {
			title: '',
		},
	},
	{
		path: '/cars',
		name: 'Cars',
		component: () => import('../views/Cars.vue'),
		meta: {
			title: '名古屋店',
		},
	},
	{
		path: '/osaka',
		name: 'Osaka',
		component: () => import('../views/Osaka.vue'),
		meta: {
			title: '大阪店',
		},
	},
	{
		path: '/hokuriku',
		name: 'Hokuriku',
		component: () => import('../views/Hokuriku.vue'),
		meta: {
			title: '北陸店',
		},
	},
	{
		path: '/kawasaki',
		name: 'Kawwasaki',
		component: () => import('../views/Kawasaki.vue'),
		meta: {
			title: '神奈川店',
		},
	},
	//{
	//	path: '/price',
	//	name: 'Price',
	//	component: () => import('../views/Price.vue'),
	//	meta: {
	//		title: 'シェア料金',
	//	},
	//},
	{
		path: '/faq',
		name: 'Faq',
		component: () => import('../views/Faq.vue'),
		meta: {
			title: 'よくある質問',
		},
	},
	{
		path: '/access',
		name: 'Access',
		component: () => import('../views/Access.vue'),
		meta: {
			title: 'アクセス',
		},
	},
	{
		path: '/option',
		name: 'Option',
		component: () => import('../views/Option.vue'),
		meta: {
			title: 'キャンプ道具シェア',
		},
	},
	{
		path: '/guide',
		name: 'Guide',
		component: () => import('../views/Guide.vue'),
		meta: {
			title: 'ご利用ガイド',
		},
	},
	{
		path: '/company',
		name: 'Company',
		component: () => import('../views/Company.vue'),
		meta: {
			title: '運営会社',
		},
	},
	{
		path: '/contact',
		name: 'Contact',
		component: () => import('../views/Contact.vue'),
		meta: {
			title: 'ご予約／お問合せ',
		},
	},
	{
		path: '/contact/:modeNo',
		name: 'ContactSelected',
		component: () => import('../views/Contact.vue'),
		meta: {
			title: 'ご予約／お問合せ',
		},
	},
	{
		path: '/contact/:modeNo/:carNo',
		name: 'ContactSelected',
		component: () => import('../views/Contact.vue'),
		meta: {
			title: 'ご予約／お問合せ',
		},
	},
	{
		path: '/thanks',
		name: 'Thanks',
		component: () => import('../views/Thanks.vue'),
		meta: {
			title: 'ご予約／お問合せ',
		},
	},
	{
		path: '/owner-entry',
		name: 'OwnerEntry',
		component: () => import('../views/OwnerEntry.vue'),
		meta: {
			title: 'オーナー様募集',
		},
	},
	{
		path: '/coating',
		name: 'Coating',
		component: () => import('../views/Coating.vue'),
		meta: {
			title: 'コーティング',
		},
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
